module.exports = __webpack_public_path__ + "img/spot5.77e4856b.png";